import { GOOGLE_API_KEY } from '@/constants/env'
import Vue from 'vue'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: GOOGLE_API_KEY
})

// CAUSING ERROR WITH MAPS LOADER
